<div class="scr">
<div class="full">
<div class="container">

  <div class="styl">

    <h1 class="head">Heart Disease Prediction</h1>
    <div class="head1">
    <h2><em>Know Your Disease</em></h2>
    <h3><em>Save Your Life</em></h3>
    </div>
    <div>
      <h1 style="text-align:center" class="head" >Human Heart</h1>
      <p style="margin-bottom:10px;">The human heart is an organ that pumps blood throughout the body via the circulatory system, supplying oxygen and nutrients to the tissues and removing carbon dioxide and other wastes. ... "If [the heart] is not able to supply blood to the organs and tissues, they'll die. The heart is a muscular organ in most animals, which pumps blood through the blood vessels of the circulatory system. Blood provides the body with oxygen and nutrients, as well as assisting in the removal of metabolic wastes. In humans, the heart is located between the lungs, in the middle compartment of the chest.</p>
    </div>
  </div>

</div>

</div>
<div class="container">
  <div class="row">
    <div class="col-md-5 m-1">
      <div class="card">
        <div class="card-header">
          <h1 style="text-align:center; color:darkblue; font-weight:bold">Admin Login</h1>
        </div>
        <div class="card-body">
          <img src="assets/images/admin.jpg" class="card-img-top">
        </div>
        <div class="card-footer" style="text-align:center">
          <h2><a routerLink="/adminlogin" mat-raised-button>Login</a></h2>
        </div>
      </div>
    </div>
    <div class="col-md-5 m-1">
      <div class="card">
        <div class="card-header">
          <h1 style="text-align:center; color:darkblue; font-weight:bold">User Login</h1>
        </div>
        <div class="card-body">
          <img src="assets/images/user.jpg" class="card-img-top">
        </div>
        <div class="card-footer" style="text-align:center">
          <h2><a routerLink="/login" mat-raised-button>Login</a></h2>
        </div>
      </div>
    </div>
  </div>

</div>

<h2 class="m-2 pop">We recommend you to please give your valuable feedback after prediction. </h2>

</div>
